import { ReactElement } from "react";

import { PaymentFormConfig } from "@evergiving/common/dist/es2015/form";

import { PledgePayment } from "@/lib/components/PledgePayment";
import { Nav } from "@/lib/components/Nav";
import { CountrySwitcher } from "@/lib/components/CountrySwitcher";
import { LogoContainer } from "@/lib/components/LogoContainer";
import { PageContainer } from "@/lib/components/PageContainer";

export function PledgePaymentIndexPage({
  formConfig,
}: {
  formConfig: PaymentFormConfig;
}): ReactElement {
  return (
    <div id="container" className="paymentFormOtherMethod">
      <header className="small">
        <LogoContainer formConfig={formConfig} />
      </header>
      <CountrySwitcher otherLocales={formConfig.otherLocales} />
      <PageContainer formConfig={formConfig}>
        <main lang={formConfig.locale}>
          <Nav
            paymentFieldConfig={formConfig.payment}
            locale={formConfig.locale}
          />
          <PledgePayment formConfig={formConfig} alwaysVisible />
        </main>
      </PageContainer>
    </div>
  );
}
